import script from "./ClientNew.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientNew.vue?vue&type=script&setup=true&lang=js"

import "./ClientNew.vue?vue&type=style&index=0&id=7c3589f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c3589f0"]])

export default __exports__